import { createExporter } from "utils/createExporter";
import { ACADEMIC_YEARS } from "utils/constants";
import { determineStatus } from "utils/helpers";
import { administrationRequests } from "api/administrationApi";

const cols = [
  { key: "name", label: "име" },
  { key: "typeText", label: "тип" },
  { key: "academicYearName", label: "академична година" },
  { key: "startsOn", label: "стартира на" },
  { key: "endsOn", label: "приключва на" },
  { key: "status", label: "статус" },
  { key: "structuralUnit", label: "структурна единица" },
  { key: "instructionLanguage", label: "език на обучение" },
];

export const SessionExporter = name => {
  const isAcademicYear = name === ACADEMIC_YEARS;

  const columns = isAcademicYear
    ? cols.filter(c => ["name", "startsOn", "endsOn"].includes(c.key))
    : cols.filter(c => c.key !== "name");

  const mapper = isAcademicYear
    ? record => ({
        ...record,
        startsOn: record.opensOn,
        endsOn: record.closesOn,
      })
    : record => ({
        ...record,
        structuralUnit: record.structuralUnit?.name,
        instructionLanguage: record.instructionLanguage?.name,
        startsOn: record.startsOnFormatted,
        endOn: record.endsOnFormatted,
        status: determineStatus(record.startsInDays, record.endsInDays),
      });

  const relations = isAcademicYear
    ? []
    : [
        {
          source: "structuralUnitId",
          target: administrationRequests.getStructuralUnitsSelect(),
          name: "structuralUnit",
        },
        {
          source: "instructionLanguageId",
          target: administrationRequests.getInstructionLanguagesSelect(),
          name: "instructionLanguage",
        },
      ];

  const fileName = name.replace(/[-/]/g, "_");

  return createExporter(`student_${fileName}.xlsx`, columns, mapper, relations);
};
